import { cva } from 'class-variance-authority'
import { cn } from '@/ui/utils/style'
import { SideDrawerTabs } from '@/domain/state/sideDrawer'
import { useSideDrawer } from '@/domain/hooks/useSideDrawer'
import { RiskLevel } from '@/domain/common/risk'

const buttonStyles = cva('border-b-2 pb-4 transition-colors disabled:pointer-events-none hover:text-white', {
  variants: {
    active: {
      true: 'border-primary text-primary',
      false: 'border-transparent text-link-inactive',
    },
  },
})

const tabs = Object.values(SideDrawerTabs)

export function TabSelector({ highestRiskLevel }: { highestRiskLevel: RiskLevel | null }) {
  const { activeTab, setActiveTab, positionsTab } = useSideDrawer()
  const { showPositionsBadge, setShowPositionsBadge } = positionsTab

  return (
    <div className={'flex gap-4'}>
      {tabs.map((tab) => (
        <button
          key={tab}
          className={cn(buttonStyles({ active: activeTab === tab }), 'relative pb-2 text-sm')}
          onClick={() => {
            setActiveTab(tab)
            setShowPositionsBadge(false)
          }}
          disabled={activeTab === tab}
        >
          {tab}
          {tab === SideDrawerTabs.POSITIONS && highestRiskLevel !== 'unknown' && showPositionsBadge && (
            <span
              className={cn(
                badgeVariants({ variant: highestRiskLevel }),
                '-right-2 absolute top-0 h-[6px] w-[6px] rounded-full',
              )}
            />
          )}
        </button>
      ))}
    </div>
  )
}

const badgeVariants = cva('rounded-[8px] border', {
  variants: {
    variant: {
      liquidation: 'bg-product-red',
      risky: 'bg-product-red',
      moderate: 'bg-product-orange',
      healthy: 'bg-product-green',
      'no debt': 'bg-product-green',
      unknown: 'bg-white/20',
    },
  },
})
